import { AttendanceClockCard } from './home/AttendanceClockCard.js';
import { AttendanceTrendChart } from './home/AttendanceTrendChart.js';
import { BirthdayAnniversary } from './home/BirthdayAnniversary.js';
import { LeaveBalanceCard } from './home/LeaveBalanceCard.js';
import { MonthCalendar } from './home/MonthCalendar.js';
import { MotivationCard } from './home/MotivationCard.js';
import { MyAnnouncements } from './home/MyAnnouncements.js';
import { PendingLeavesCard } from './home/PendingLeavesCard.js';
import { HomeGate } from './home/HomeGate.js';
import { QuickActions } from './home/QuickActions.js';
import { QuickPollCard } from './home/QuickPollCard.js';
import { UpcomingEvents } from './home/UpcomingEvents.js';
import { UpcomingHolidays } from './home/UpcomingHolidays.js';
import { WelcomeRedirect } from '../features/setup/WelcomeRedirect.js';
import { ActivationCard } from '../features/setup/activation/ActivationCard.js';
import { TeamSmsInvites } from '../features/setup/activation/TeamSmsInvites.js';
import { SignupShiftApplier } from '../features/setup/activation/SignupShiftApplier.js';
import { ContinueLearningCard } from '../features/learning/home/ContinueLearningCard.js';
import { Skeleton } from '@hrms/ui';
import { WhenVisible } from '../components/WhenVisible.js';

/** Holds a below-the-fold card's space until it scrolls near (see WhenVisible). */
const CARD_PLACEHOLDER = <Skeleton className="h-56" />;

export function Home() {
  return (
    <div className="flex flex-col gap-6 [container-type:inline-size]">
      {/* Main 3-row grid with Container Query responsiveness */}
      <div className="flex flex-col gap-5">
        {/* Opens Add your team for a new company's owner, once (FR-4). Renders nothing otherwise. */}
        <WelcomeRedirect />
        {/* "Get your HRMS active" for whoever adds employees, until the team is in and has clocked in. */}
        <ActivationCard />
        {/* "Text your team their invite" while phone-only people have not signed in (opens as a
            sheet on /?invite=sms, where sign-up lands after Add your team). */}
        <TeamSmsInvites />
        {/* Sets the shifts picked on sign-up's Add your team (/?invite=sms&shifts=…). Renders nothing. */}
        <SignupShiftApplier />
        {/* Row 1 */}
        <div className="grid grid-cols-1 @min-[850px]:grid-cols-2 @min-[1200px]:grid-cols-12 gap-5 items-stretch">
          <HomeGate module="attendance">
            <div className="@min-[1200px]:col-span-5">
              <AttendanceClockCard />
            </div>
          </HomeGate>
          <div className="@min-[1200px]:col-span-4">
            <QuickActions />
          </div>
          <HomeGate module="leave">
            <div className="@min-[1200px]:col-span-3 @min-[850px]:col-span-2 @min-[1200px]:col-span-3">
              <PendingLeavesCard />
            </div>
          </HomeGate>
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 @min-[600px]:grid-cols-2 @min-[1200px]:grid-cols-4 gap-5 items-stretch">
          <HomeGate module="leave">
            <LeaveBalanceCard />
          </HomeGate>
          <HomeGate module="leave">
            <UpcomingHolidays />
          </HomeGate>
          <UpcomingEvents />
          <HomeGate module="leave">
            <MonthCalendar />
          </HomeGate>
        </div>

        {/* Row 3 — below the fold on most screens, so each card mounts (and fetches) only as it
            scrolls near. Rows 1 and 2 load at once: they are what the page opens on. */}
        <div className="grid grid-cols-1 @min-[600px]:grid-cols-2 @min-[1200px]:grid-cols-4 gap-5 items-stretch">
          <HomeGate module="attendance">
            <WhenVisible placeholder={CARD_PLACEHOLDER}>
              <AttendanceTrendChart />
            </WhenVisible>
          </HomeGate>
          {/* Announcements are Engage's, and are sent over Chat's channel: both must be on. */}
          <HomeGate module={['engage', 'chat']}>
            <WhenVisible placeholder={CARD_PLACEHOLDER}>
              <MyAnnouncements />
            </WhenVisible>
          </HomeGate>
          <HomeGate module="engage">
            <WhenVisible placeholder={CARD_PLACEHOLDER}>
              <BirthdayAnniversary />
            </WhenVisible>
          </HomeGate>
          {/* Its button opens Performance. */}
          <HomeGate module="performance_okr">
            <MotivationCard />
          </HomeGate>
        </div>

        {/* Quick poll (ADR 0027) — only when one is open for the viewer — and Continue learning
            (training redesign R15) — only when a course is assigned. Both render nothing otherwise. */}
        <div className="grid grid-cols-1 @min-[600px]:grid-cols-2 @min-[1200px]:grid-cols-4 gap-5 items-stretch empty:hidden">
          {/* No placeholder: both may render nothing, and this row must stay empty (hidden) then. */}
          <HomeGate module="engage">
            <WhenVisible>
              <QuickPollCard />
            </WhenVisible>
          </HomeGate>
          <HomeGate module="training" permission="learning:read">
            <WhenVisible>
              <ContinueLearningCard />
            </WhenVisible>
          </HomeGate>
        </div>
      </div>
    </div>
  );
}
